import Vue from "vue";
import i18n from "@/plugins/i18n/translations";

export default {
  state: {
    translations: [],
    translationPagination: {},
    entities: []
  },
  mutations: {
    setTranslationsOnState(state, translation) {
      state.translations = translation;
    },
    setTranslationsPaginationOnState(state, translationPagination) {
      state.translationPagination = translationPagination;
    },
    setEntitiesOnState(state, entities) {
      state.entities = entities;
    },
  },
  actions: {
    getTranslationsWithPagination({ commit }, dataObject) {
      this.state.loading = true;
      delete dataObject.entity;
      return new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post("translation/pagination", dataObject)
          .then((response) => {
            commit("setTranslationsOnState", response.data.data.list);
            commit("setTranslationsPaginationOnState", response.data.data.pagination);
            resolve(response.data.data.pagination);
            this.state.loading = false;
          })
          .catch(() => {
            this.state.loading = false;
            reject();
          })
      })
    },
    updateTranslation(_, statusData) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http
          .put("translation/update", statusData)
          .then((response) => {
            this.state.loading = false;
            resolve(response.data.data);
          })
          .catch(() => {
            this.state.loading = false;
            reject();
          });
      });
    },
    getTranslations(_, dataObject) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get("translation/get", dataObject)
          .then((response) => {
            resolve(response.data.data);
            this.state.loading = false;
          })
          .catch(() => {
            this.state.loading = false;
            reject();
          })
      })
    },
    getAllEntities({ commit }) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get("translation/entities")
          .then((response) => {
            const mapEntitiesToDropDown = mapEntities(response.data.data.entities);
            commit("setEntitiesOnState", mapEntitiesToDropDown);
            resolve(mapEntitiesToDropDown);
            this.state.loading = false;
          })
          .catch(() => {
            this.state.loading = false;
            reject();
          })
      })
    }
  },
  getters: {
    translations({ translations }) {
      return translations;
    },
    translationPagination({ translationPagination }) {
      return translationPagination;
    },
    entities({ entities }) {
      return entities;
    }
  }

}
function mapEntities(entities) {
  const mappedEntities = [];
  if (entities) {
    entities.map((entity, index) => {
      mappedEntities.push({
        backName: entity,
        name: i18n.t(`commons.translationEntity.${entity}`),
        id: index,
        label: false
      });
    });
  }
  return mappedEntities;
}